import { admin2 } from '@/api/instance'
import { useShop } from './shop'
import { get } from 'lodash'

export const useS3 = () => {
  const { shopId } = useShop()
  const uploadToS3 = async (file) => {
    try {
      // 1. 先獲取預簽名 URL
      const [res, errMsg] = await admin2({
        method: 'GET',
        url: `/${shopId.value}/awsS3Upload/getUploadPresignedUrl?contentType=${file.type}`,
      })

      if (errMsg) {
        return [null, errMsg]
      }

      if (res.url) {
        await fetch(res.url, {
          method: 'PUT',
          body: file,
          headers: {
            'Content-Type': file.type,
          },
        })
      }

      return [get(res, 'path'), null]
    } catch (error) {
      return [null, error]
    }
  }

  return {
    uploadToS3,
  }
}
